import type { ContentValidator, ValidationResult } from '@ai-content-hub/content-core';
import type { DocumentsData } from './schema';
import { hasConfiguredOfficeDocument } from './schema';

export const documentsValidator: ContentValidator<DocumentsData> = {
    validate(data: DocumentsData): ValidationResult {
        if (!hasConfiguredOfficeDocument(data)) {
            return {
                isValid: false,
                errors: [
                    {
                        field: 'pageContent',
                        message: 'Add at least one Document block with a file or URL.',
                    },
                ],
            };
        }
        return { isValid: true, errors: [] };
    },
};
